var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopbottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_133_217)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14,
    r: 13.5,
    fill: "white",
    stroke: "#FF9777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6765 14C20.6765 14.1365 20.6222 14.2674 20.5257 14.364C20.4292 14.4605 20.2983 14.5147 20.1618 14.5147H8.83823C8.70173 14.5147 8.57081 14.4605 8.47428 14.364C8.37776 14.2674 8.32353 14.1365 8.32353 14C8.32353 13.8635 8.37776 13.7326 8.47428 13.6361C8.57081 13.5395 8.70173 13.4853 8.83823 13.4853H20.1618C20.2983 13.4853 20.4292 13.5395 20.5257 13.6361C20.6222 13.7326 20.6765 13.8635 20.6765 14ZM12.8079 9.21967L13.9853 8.03585V11.9412C13.9853 12.0777 14.0395 12.2086 14.136 12.3051C14.2326 12.4017 14.3635 12.4559 14.5 12.4559C14.6365 12.4559 14.7674 12.4017 14.864 12.3051C14.9605 12.2086 15.0147 12.0777 15.0147 11.9412V8.03585L16.1921 9.21967C16.2905 9.3148 16.422 9.36798 16.5588 9.36798C16.6957 9.36798 16.8272 9.3148 16.9256 9.21967C17.0222 9.12209 17.0764 8.99029 17.0764 8.85294C17.0764 8.7156 17.0222 8.5838 16.9256 8.48622L14.8667 6.42739C14.7691 6.33074 14.6373 6.27652 14.5 6.27652C14.3627 6.27652 14.2309 6.33074 14.1333 6.42739L12.0744 8.48622C11.9924 8.58622 11.9504 8.71318 11.9568 8.8424C11.9631 8.97162 12.0173 9.09386 12.1088 9.18534C12.2003 9.27682 12.3225 9.331 12.4517 9.33735C12.5809 9.34369 12.7079 9.30175 12.8079 9.21967ZM16.1921 18.7803L15.0147 19.9642V16.0588C15.0147 15.9223 14.9605 15.7914 14.864 15.6949C14.7674 15.5983 14.6365 15.5441 14.5 15.5441C14.3635 15.5441 14.2326 15.5983 14.136 15.6949C14.0395 15.7914 13.9853 15.9223 13.9853 16.0588V19.9642L12.8079 18.7803C12.7079 18.6983 12.5809 18.6563 12.4517 18.6627C12.3225 18.669 12.2003 18.7232 12.1088 18.8147C12.0173 18.9062 11.9631 19.0284 11.9568 19.1576C11.9504 19.2868 11.9924 19.4138 12.0744 19.5138L14.1333 21.5726C14.2317 21.6677 14.3631 21.7209 14.5 21.7209C14.6368 21.7209 14.7683 21.6677 14.8667 21.5726L16.9256 19.5138C17.0076 19.4138 17.0496 19.2868 17.0432 19.1576C17.0369 19.0284 16.9827 18.9062 16.8912 18.8147C16.7997 18.7232 16.6775 18.669 16.5483 18.6627C16.4191 18.6563 16.2921 18.6983 16.1921 18.7803Z",
    fill: "#FF9777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopbottom);
export default __webpack_public_path__ + "static/media/topbottom.ad875293df16b75029047483310883a9.svg";
export { ForwardRef as ReactComponent };